export default class Arr {
  static wrap(item) {
    if (item === undefined) {
      return [];
    }

    if (Array.isArray(item)) {
      return item;
    }

    return [item];
  }

  static toHtml(items, tag) {
    tag = tag || "p";

    let html = '';

    items = Arr.wrap(items);

    for (let i in items) {
      if (items.hasOwnProperty(i)) {
        html += `<${tag}>${items[i]}</${tag}>` + "\n";
      }
    }

    return html;
  }
}
